import axios from "axios";
import * as types from "./mutation_types";

export const retrieve = ({ commit }, id) => {
  commit(types.SESSION_SHOW_TOGGLE_LOADING);

  axios
    .get("/api/sessions/" + id + "/")
    .then((response) => {
      commit(types.SESSION_SHOW_TOGGLE_LOADING);
      commit(types.SESSION_SHOW_SET_RETRIEVED, response.data);
    })
    .catch((e) => {
      commit(types.SESSION_SHOW_TOGGLE_LOADING);
      commit(types.SESSION_SHOW_SET_ERROR, e.message);
    });
};

export const reset = ({ commit }) => {
  commit(types.SESSION_SHOW_RESET);
};
